import React from 'react';
import './CaptureOverlay.css';

export interface CaptureOverlayProps {
  children: React.ReactNode;
  taskName?: string;
  onClose: () => void;
  statusBadge?: React.ReactNode;
}

export const CaptureOverlay: React.FC<CaptureOverlayProps> = ({
  children,
  taskName,
  onClose,
  statusBadge,
}) => {
  return (
    <div className="co-overlay">
      <div className="co-header">
        <button className="co-close" onClick={onClose} aria-label="Close">✕</button>
        {statusBadge || (taskName && <div className="co-task-name">{taskName}</div>)}
        <div className="co-header-spacer" />
      </div>
      {children}
    </div>
  );
};
